import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ApplicationItem } from '../../models/application.interface';
import { ApplicationDetailDialogComponent } from '../application-detail-dialog/application-detail-dialog.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-application-card',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatButtonModule],
  templateUrl: './application-card.component.html',
  styleUrls: ['./application-card.component.css']
})
export class ApplicationCardComponent {
  private translate = inject(TranslateService);
  private dialog = inject(MatDialog);

  @Input({ required: true }) application!: ApplicationItem;

  get companyName(): string {
    return this.application.supplier?.companyName || this.application.companyName || '—';
  }

  getStatusText(status: string): string {
    const statusMap: Record<string, string> = {
      'APPROVED': 'Одобрено',
      'REJECTED': 'Отклонено',
      'UNDER_CONSIDERATION': 'На проверке',
      'PENDING': 'На рассмотрении'
    };
    return statusMap[status] ?? status;
  }

  getStatusClass(status: string): string {
    return `status-${status.toLowerCase().replace(/_/g, '-')}`;
  }

  getTons(kilograms: number): string {
    return (kilograms / 1000).toLocaleString('ru-RU', { maximumFractionDigits: 2 });
  }

  getMeatTypeName(): string {
    const lang = this.translate.currentLang || 'ru';
    return lang === 'ky' ? this.application.meatType.nameKy : this.application.meatType.nameRu;
  }

  openDetail(): void {
    const isMobile = window.innerWidth <= 480;
    this.dialog.open(ApplicationDetailDialogComponent, {
      data: this.application,
      width: isMobile ? '100vw' : '600px',
      maxWidth: isMobile ? '100vw' : '95vw',
      maxHeight: isMobile ? '100dvh' : '90vh'
    });
  }
}
